export default "__VITE_ASSET__CxSmZmyF__"